const TRACKINGDATA = {
  whyLeaseWithUs:
  {
    'Event Metadata': {
      action_category: 'current offers selector',
      action_type: 'modal',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:selector:[click text]',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
    ],
  },
  selectAVehicle:
  {
    'Event Metadata': {
      action_category: 'current offers selector',
      action_type: 'selector',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:selector:',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
    ],
  },
  zipCodeSearch:
  {
    'Event Metadata': {
      action_category: 'current offers selector',
      action_type: 'selector',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:selector:zip search',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'current_offers_zip_code',
        parent: 'Offer',
        type: 'fieldValue',
        search: 'offers-change-zip input',
      },
    ],
  },
  zipCodeSubmit:
  {
    'Event Metadata': {
      action_category: 'current offers zip gate',
      action_type: 'selector',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:zip gate:zip search',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'current_offers_zip_code',
        parent: 'Offer',
        type: 'fieldValue',
        search: 'offers-zipgate input',
      },
    ],
  },
  getThisOffer:
  {
    Offer: {
      offer_type: '',
      offer_amount: '',
      offer_name: '',
      offer_date: '',
      offer_model: '',
      offer_model_year: '',
      offer_term: '',
      offer_duration: '',
      offer_expire: '',
      offer_start: '',
      offer_id: '',
    },
    'Event Metadata': {
      action_category: 'current offers results',
      action_type: 'cta',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:results:',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
    ],
  },
  offerDetail:
  {
    Offer: {
      offer_type: '',
      offer_amount: '',
      offer_name: '',
      offer_date: '',
      offer_model: '',
      offer_model_year: '',
      offer_term: '',
      offer_duration: '',
      offer_expire: '',
      offer_start: '',
      offer_id: '',
    },
    'Event Metadata': {
      action_type: 'selector',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:results:',
        type: 'dynamicName',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] results',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
    ],
  },
  offerDetailCTAs:
  {
    Offer: {
      offer_type: '',
      offer_amount: '',
      offer_name: '',
      offer_date: '',
      offer_model: '',
      offer_model_year: '',
      offer_term: '',
      offer_duration: '',
      offer_expire: '',
      offer_start: '',
      offer_id: '',
    },
    'Event Metadata': {
      action_type: 'cta',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:results:',
        type: 'dynamicName',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] results',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
    ],
  },
  offerDetailLinks:
  {
    Offer: {
      offer_type: '',
      offer_amount: '',
      offer_name: '',
      offer_date: '',
      offer_model: '',
      offer_model_year: '',
      offer_term: '',
      offer_duration: '',
      offer_expire: '',
      offer_start: '',
      offer_id: '',
    },
    'Event Metadata': {
      action_type: 'link',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:results:',
        type: 'dynamicName',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] results',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
    ],
  },
  offersBanner:
  {
    'Event Metadata': {
      action_category: 'current offers footer banner',
      action_type: 'cta',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:footer banner:[click text]',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
    ],
  },
  allModelOffersCta:
  {
    'Event Metadata': {
      action_type: 'cta',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:results:see all [model_name] offers',
        type: 'dynamicName',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] results',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
    ],
  },
};

export default TRACKINGDATA;
